export default __webpack_public_path__ + "static/media/single-project-page-04-img12.4e586eff.png";